interface Params {
  onError?: () => void;
  url: string;
}

const waitForVideo = ({ onError, url }: Params) => {
  return new Promise((resolve) => {
    const video = document.createElement('video');
    let errors = 0;
    video.onloadedmetadata = () => {
      resolve(true);
    };
    video.onerror = () => {
      if (onError) onError();
      if (errors > 1000) resolve(false);
      errors++;
      setTimeout(() => {
        video.src = url;
      }, 5000);
    };
    video.src = url;
  });
};

export default waitForVideo;
